import React from "react";
import PropTypes from "prop-types";
import MatchingText from "../../../component/matchingText/MatchingText";
import "./SearchRecommendationItem.scss";

/**
 * 추천 검색어 아이템 컴포넌트
 * @param data 추천 검색어 데이터 (text 포함)
 * @param searchQuery 검색어
 * @param onClick 검색 실행 함수
 * @returns {JSX.Element}
 */
const SearchRecommendationItem = ({ data, searchQuery, onClick }) => {
  return (
    <div
      className="search-recommendation-item"
      onClick={() => onClick(data.text)}
    >
      <div className="search-recommendation-text">
        <MatchingText fullText={data.text} matchText={searchQuery} />
      </div>
    </div>
  );
};

SearchRecommendationItem.propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string.isRequired,
  }).isRequired,
  searchQuery: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

SearchRecommendationItem.displayName = "SearchRecommendationItem";

export default React.memo(SearchRecommendationItem);
